/** Action key that carries API call info interpreted by this Redux Middleware. */
export const API_REQUEST = 'API_REQUEST';
